import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CompanyDataAnalysisOptions, defaultChartOrTableHeight, eurekaIPSortList, eurekaMaterialsSortList, eurekaRdPvUvSortList, makeEurekaActiveUserTableRows } from './CompanyDataAnalysisService';
import { Symbols } from '@/symbols';
import _ from 'lodash';
import { CompanyDataAnalysisDataSet, CompanyDataAnalysisEventKey, CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
import { searchColor } from './echartsOption';
let CompanyEurekaDataAnalysisService = class CompanyEurekaDataAnalysisService {
    constructor(companyDataAnalysisService, companyDataAnalysisApi, i18n) {
        this.companyDataAnalysisService = companyDataAnalysisService;
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.i18n = i18n;
        /**
         * noveltyCheck option
         */
        this.noveltyCheckOption = new CompanyDataAnalysisOptions();
        this.searchOption = new CompanyDataAnalysisOptions();
        // 登录Eureka
        this.loginEurekaPvOption = new CompanyDataAnalysisOptions();
        this.loginEurekaUvOption = new CompanyDataAnalysisOptions();
        // RD
        this.rdPvOption = new CompanyDataAnalysisOptions();
        this.rdUvOption = new CompanyDataAnalysisOptions();
        // ip
        this.ipPvOption = new CompanyDataAnalysisOptions();
        this.ipUvOption = new CompanyDataAnalysisOptions();
        // materials
        this.materialsPvOption = new CompanyDataAnalysisOptions();
        this.materialsUvOption = new CompanyDataAnalysisOptions();
        // 新增用户配置
        this.newUserPermissionOption = new CompanyDataAnalysisOptions();
        /**
         * 新用户获取权限 Detail 配置
         */
        this.newUserPermissionDetailOption = new CompanyDataAnalysisOptions();
        /**
         * 用户明细 table 配置
         */
        this.userDetailOption = new CompanyDataAnalysisOptions();
        this.noveltyCheckConfigInit();
        this.searchConfigInit();
        this.newUserPermissionConfigInit();
        this.newUserPermissionDetailConfigInit();
        this.loginEurekaPvConfigInit();
        this.loginEurekaUvConfigInit();
        this.rdPvConfigInit();
        this.rdUvConfigInit();
        this.materialsPvConfigInit();
        this.materialsUvConfigInit();
        this.ipPvConfigInit();
        this.ipUvConfigInit();
        this.userDetailConfigInit();
    }
    noveltyCheckConfigInit() {
        this.noveltyCheckOption.reportName = CompanyDataAnalysisKeyType.EUREKA_TECH_IDEA_SEARCH;
        this.noveltyCheckOption.title = this.i18n.t('backoffice.company.dataAnalysis.noveltyCheck');
        this.noveltyCheckOption.canCollapse = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.commonPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.commonUv'),
        };
        this.noveltyCheckOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.noveltyCheckOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.noveltyCheckOption.chartId = 'noveltyCheckAnalysis';
        this.noveltyCheckOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getNoveltyCheckData(params) {
        this.noveltyCheckOption.loading = true;
        const concurrencyParams = { ...params, report_name: this.noveltyCheckOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(concurrencyParams).then(data => {
            this.noveltyCheckOption.Updated = data.data_date;
            this.searchOption.Updated = data.data_date;
            this.noveltyCheckOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'common',
            };
            this.noveltyCheckOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.noveltyCheckOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.TECH_IDEA_SEARCH);
            const optionParams = {
                data: data.data_detail,
                total_count: this.noveltyCheckOption.statistics[0].label,
                user_count: this.noveltyCheckOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.TECH_IDEA_SEARCH,
            };
            this.noveltyCheckOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.noveltyCheckOption.noData = true;
        }).finally(() => {
            this.noveltyCheckOption.loading = false;
        });
    }
    searchConfigInit() {
        this.searchOption.reportName = CompanyDataAnalysisKeyType.EUREKA_SEARCH;
        this.searchOption.title = this.i18n.t('backoffice.company.dataAnalysis.search');
        this.searchOption.canCollapse = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.commonPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.commonUv'),
        };
        this.searchOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.searchOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.searchOption.chartId = 'searchAnalysis';
        this.searchOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getSearchData(params) {
        this.searchOption.loading = true;
        const searchParams = { ...params, report_name: this.searchOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(searchParams).then(data => {
            this.searchOption.Updated = data.data_date;
            this.searchOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'common',
            };
            this.searchOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.searchOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.EUREKA_SEARCH);
            const optionParams = {
                data: data.data_detail,
                total_count: this.searchOption.statistics[0].label,
                user_count: this.searchOption.statistics[1].label,
                key: CompanyDataAnalysisEventKey.EUREKA_SEARCH,
            };
            this.searchOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.searchOption.noData = true;
        }).finally(() => {
            this.searchOption.loading = false;
        });
    }
    loginEurekaPvConfigInit() {
        this.loginEurekaPvOption.reportName = CompanyDataAnalysisKeyType.EUREKA_LOGIN;
        this.loginEurekaPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.loginPv');
        this.loginEurekaPvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.loginEurekaPvTips') }];
        this.loginEurekaPvOption.canCollapse = false;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.loginPv'),
        };
        this.loginEurekaPvOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.loginEurekaPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.loginEurekaPvOption.chartId = 'loginEurekaPvAnalysis';
        this.loginEurekaPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    loginEurekaUvConfigInit() {
        this.loginEurekaUvOption.reportName = CompanyDataAnalysisKeyType.EUREKA_LOGIN;
        this.loginEurekaUvOption.title = this.i18n.t('backoffice.company.dataAnalysis.loginUv');
        this.loginEurekaUvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.loginEurekaUvTips') }];
        this.loginEurekaUvOption.canCollapse = false;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.loginUv'),
        };
        this.loginEurekaUvOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.loginEurekaUvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.loginEurekaUvOption.chartId = 'loginEurekaUvAnalysis';
        this.loginEurekaUvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getLoginEurekaPvUvData(params) {
        this.loginEurekaPvOption.loading = true;
        const loginEurekaPvParams = { ...params, report_name: this.loginEurekaPvOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(loginEurekaPvParams).then((data) => {
            this.loginEurekaPvOption.Updated = data.data_date;
            this.loginEurekaPvOption.noData = data.data_detail.length === 0;
            this.loginEurekaPvOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.LOGIN);
            this.loginEurekaPvOption.chartOption = this.companyDataAnalysisService.getLineChartOption({
                data,
                sortList: [CompanyDataAnalysisEventKey.LOGIN],
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                columns: [{
                        label: this.i18n.t('backoffice.company.dataAnalysis.loginPv'),
                        field: CompanyDataAnalysisEventKey.LOGIN,
                    }],
            });
            this.loginEurekaUvOption.Updated = data.data_date;
            this.loginEurekaUvOption.noData = data.data_detail.length === 0;
            this.loginEurekaUvOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.LOGIN);
            this.loginEurekaUvOption.chartOption = this.companyDataAnalysisService.getLineChartOption({
                data,
                sortList: [CompanyDataAnalysisEventKey.LOGIN],
                dataSet: CompanyDataAnalysisDataSet.USER_COUNT,
                columns: [{
                        label: this.i18n.t('backoffice.company.dataAnalysis.loginUv'),
                        field: CompanyDataAnalysisEventKey.LOGIN,
                    }],
            });
        }).finally(() => {
            this.loginEurekaPvOption.loading = false;
            this.loginEurekaUvOption.loading = false;
        });
    }
    rdPvConfigInit() {
        this.rdPvOption.reportName = CompanyDataAnalysisKeyType.EUREKA_RD_USAGE_REPORT;
        this.rdPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonPv');
        this.rdPvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonPvTips') }];
        this.rdPvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.rdPvOption.canChangeViewType = true;
        this.rdPvOption.canCollapse = false;
        this.rdPvOption.statistics = [];
        this.rdPvOption.tableOptions.columns = this.companyDataAnalysisService.getEurekaRdTableColumns();
        this.rdPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.rdPvOption.chartId = 'rdPv';
        this.rdPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    rdUvConfigInit() {
        this.rdUvOption.reportName = CompanyDataAnalysisKeyType.EUREKA_RD_USAGE_REPORT;
        this.rdUvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonUv');
        this.rdUvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonUvTips') }];
        this.rdUvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.rdUvOption.canChangeViewType = true;
        this.rdUvOption.canCollapse = false;
        this.rdUvOption.statistics = [];
        this.rdUvOption.tableOptions.columns = this.companyDataAnalysisService.getEurekaRdTableColumns();
        this.rdUvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.rdUvOption.chartId = 'rdUv';
        this.rdUvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getRdPvUvData(params) {
        this.rdPvOption.loading = true;
        this.rdUvOption.loading = true;
        const rdParams = { ...params, report_name: this.rdPvOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(rdParams).then((data) => {
            this.rdPvOption.Updated = data.data_date;
            this.rdUvOption.Updated = data.data_date;
            this.rdPvOption.noData = data.data_detail.length === 0;
            this.rdUvOption.noData = data.data_detail.length === 0;
            if (this.rdPvOption.noData)
                return;
            this.rdPvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.TOTAL_COUNT);
            this.rdUvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.USER_COUNT);
            this.rdPvOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaRdPvUvSortList,
                colorList: searchColor,
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                columns: this.companyDataAnalysisService.getEurekaRdTableColumns(),
            });
            this.rdUvOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaRdPvUvSortList,
                colorList: searchColor,
                dataSet: CompanyDataAnalysisDataSet.USER_COUNT,
                columns: this.companyDataAnalysisService.getEurekaRdTableColumns(),
            });
        }).catch(() => {
            this.rdPvOption.noData = true;
            this.rdUvOption.noData = true;
        }).finally(() => {
            this.rdPvOption.loading = false;
            this.rdUvOption.loading = false;
        });
    }
    ipPvConfigInit() {
        this.ipPvOption.reportName = CompanyDataAnalysisKeyType.EUREKA_IP_USAGE_REPORT;
        this.ipPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonPv');
        this.ipPvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonPvTips') }];
        this.ipPvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.ipPvOption.canChangeViewType = true;
        this.ipPvOption.canCollapse = false;
        this.ipPvOption.statistics = [];
        this.ipPvOption.tableOptions.columns = this.companyDataAnalysisService.getEurekaIPTableColumns();
        this.ipPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.ipPvOption.chartId = 'ipPv';
        this.ipPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    ipUvConfigInit() {
        this.ipUvOption.reportName = CompanyDataAnalysisKeyType.EUREKA_IP_USAGE_REPORT;
        this.ipUvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonUv');
        this.ipUvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonUvTips') }];
        this.ipUvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.ipUvOption.canChangeViewType = true;
        this.ipUvOption.canCollapse = false;
        this.ipUvOption.statistics = [];
        this.ipUvOption.tableOptions.columns = this.companyDataAnalysisService.getEurekaIPTableColumns();
        this.ipUvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.ipUvOption.chartId = 'ipUv';
        this.ipUvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getIpPvUvData(params) {
        this.ipPvOption.loading = true;
        this.ipUvOption.loading = true;
        const ipParams = { ...params, report_name: this.ipPvOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(ipParams).then((data) => {
            this.ipPvOption.Updated = data.data_date;
            this.ipUvOption.Updated = data.data_date;
            this.ipPvOption.noData = data.data_detail.length === 0;
            this.ipUvOption.noData = data.data_detail.length === 0;
            if (this.ipPvOption.noData)
                return;
            this.ipPvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.TOTAL_COUNT);
            this.ipUvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.USER_COUNT);
            this.ipPvOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaIPSortList,
                colorList: searchColor,
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                columns: this.companyDataAnalysisService.getEurekaIPTableColumns(),
            });
            this.ipUvOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaIPSortList,
                colorList: searchColor,
                dataSet: CompanyDataAnalysisDataSet.USER_COUNT,
                columns: this.companyDataAnalysisService.getEurekaIPTableColumns(),
            });
        }).catch(() => {
            this.ipPvOption.noData = true;
            this.ipUvOption.noData = true;
        }).finally(() => {
            this.ipPvOption.loading = false;
            this.ipUvOption.loading = false;
        });
    }
    materialsPvConfigInit() {
        this.materialsPvOption.reportName = CompanyDataAnalysisKeyType.EUREKA_MATERIALS_USAGE_REPORT;
        this.materialsPvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonPv');
        this.materialsPvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonPvTips') }];
        this.materialsPvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.materialsPvOption.canChangeViewType = true;
        this.materialsPvOption.canCollapse = false;
        this.materialsPvOption.statistics = [];
        this.materialsPvOption.tableOptions.columns = this.companyDataAnalysisService.getEurekaMaterialsTableColumns();
        this.materialsPvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.materialsPvOption.chartId = 'materialsPv';
        this.materialsPvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    materialsUvConfigInit() {
        this.materialsUvOption.reportName = CompanyDataAnalysisKeyType.EUREKA_MATERIALS_USAGE_REPORT;
        this.materialsUvOption.title = this.i18n.t('backoffice.company.dataAnalysis.commonUv');
        this.materialsUvOption.tips = [{ desc: this.i18n.t('backoffice.company.dataAnalysis.commonUvTips') }];
        this.materialsUvOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.materialsUvOption.canChangeViewType = true;
        this.materialsUvOption.canCollapse = false;
        this.materialsUvOption.statistics = [];
        this.materialsUvOption.tableOptions.columns = this.companyDataAnalysisService.getEurekaMaterialsTableColumns();
        this.materialsUvOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.materialsUvOption.chartId = 'materialsUv';
        this.materialsUvOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getMaterialsPvUvData(params) {
        this.materialsPvOption.loading = true;
        this.materialsUvOption.loading = true;
        const materialsParams = { ...params, report_name: this.materialsPvOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(materialsParams).then((data) => {
            this.materialsPvOption.Updated = data.data_date;
            this.materialsUvOption.Updated = data.data_date;
            this.materialsPvOption.noData = data.data_detail.length === 0;
            this.materialsUvOption.noData = data.data_detail.length === 0;
            if (this.materialsPvOption.noData)
                return;
            this.materialsPvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.TOTAL_COUNT);
            this.materialsUvOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.USER_COUNT);
            this.materialsPvOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaMaterialsSortList,
                colorList: searchColor,
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                columns: this.companyDataAnalysisService.getEurekaMaterialsTableColumns(),
            });
            this.materialsUvOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption({
                data,
                sortList: eurekaMaterialsSortList,
                colorList: searchColor,
                dataSet: CompanyDataAnalysisDataSet.USER_COUNT,
                columns: this.companyDataAnalysisService.getEurekaMaterialsTableColumns(),
            });
        }).catch(() => {
            this.materialsPvOption.noData = true;
            this.materialsUvOption.noData = true;
        }).finally(() => {
            this.materialsPvOption.loading = false;
            this.materialsUvOption.loading = false;
        });
    }
    newUserPermissionConfigInit() {
        this.newUserPermissionOption.reportName = CompanyDataAnalysisKeyType.EUREKA_NEW_USER;
        this.newUserPermissionOption.title = this.i18n.t('backoffice.company.dataAnalysis.overview');
        this.newUserPermissionOption.canCollapse = false;
        this.newUserPermissionOption.tips = [];
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
        };
        this.newUserPermissionOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.newUserPermissionOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionOption.statistics = [];
        this.newUserPermissionOption.chartId = 'newEurekaUserPermissionChart';
        this.newUserPermissionOption.chartHeight = defaultChartOrTableHeight.defaultChartHeight;
    }
    getNewUserPermissionData(params) {
        this.newUserPermissionOption.loading = true;
        const newUserPermissionParams = { ...params, report_name: this.newUserPermissionOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(newUserPermissionParams).then(data => {
            this.newUserPermissionOption.Updated = data.data_date;
            this.newUserPermissionDetailOption.Updated = data.data_date;
            this.newUserPermissionOption.noData = data.data_detail.length === 0;
            this.newUserPermissionOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.EUREKA);
            const optionParams = {
                data: data.data_detail,
                user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                key: CompanyDataAnalysisEventKey.EUREKA,
            };
            this.newUserPermissionOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.newUserPermissionOption.noData = true;
        }).finally(() => {
            this.newUserPermissionOption.loading = false;
        });
    }
    newUserPermissionDetailConfigInit() {
        this.newUserPermissionDetailOption.reportName = CompanyDataAnalysisKeyType.EUREKA_NEW_USER;
        this.newUserPermissionDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.userDetails');
        this.newUserPermissionDetailOption.tips = [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginDays'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginDaysTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginTotalCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.eurekaLoginTotalCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.joinDate'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.joinDateTips'),
            }
        ];
        this.newUserPermissionDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.enabled = true;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.newUserPermissionDetailOption.canChangeViewType = false;
        this.newUserPermissionDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.newUserPermissionDetailOption.canCollapse = false;
        this.newUserPermissionDetailOption.tableFields = this.companyDataAnalysisService.getUserTableColumns(CompanyDataAnalysisEventKey.EUREKA);
        this.newUserPermissionDetailOption.tableOptions.columns = this.newUserPermissionDetailOption.tableFields;
    }
    async getNewUserPermissionDetailsData(params) {
        let newUserPermissionDetailParams = _.cloneDeep(params);
        this.newUserPermissionDetailOption.loading = true;
        newUserPermissionDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.newUserPermissionDetailOption.reportName);
        // 先获取字段设置
        this.newUserPermissionDetailOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.newUserPermissionOption.reportName, this.newUserPermissionDetailOption.tableFields);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivileges(newUserPermissionDetailParams).then(data => {
            this.newUserPermissionDetailOption.noData = data.iTotalRecords === 0;
            this.newUserPermissionDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.newUserPermissionDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.newUserPermissionDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.newUserPermissionDetailOption.tableOptions.rows = this.companyDataAnalysisService.getUserTableRows(data.aaData, CompanyDataAnalysisEventKey.EUREKA);
        }).catch(() => {
            this.newUserPermissionDetailOption.noData = true;
        }).finally(() => {
            this.newUserPermissionDetailOption.loading = false;
        });
    }
    userDetailConfigInit() {
        this.userDetailOption.reportName = CompanyDataAnalysisKeyType.EUREKA_SUMMARY;
        this.userDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.userDetails');
        this.userDetailOption.tips = [
            ...this.newUserPermissionDetailOption.tips,
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.invalidPermission'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.invalidPermissionTips'),
            }
        ];
        this.userDetailOption.canCollapse = false;
        this.userDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeight;
        this.userDetailOption.tableOptions.paginationOptions.enabled = true;
        this.userDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.userDetailOption.canChangeViewType = false;
        this.userDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.userDetailOption.tableFields = this.companyDataAnalysisService.getEurekaActiveUserTableColumns();
        this.userDetailOption.tableOptions.columns = this.userDetailOption.tableFields;
    }
    async getEurekaUserDetailData(params) {
        let eurekaActiveUserDetailParams = _.cloneDeep(params);
        this.userDetailOption.loading = true;
        eurekaActiveUserDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.userDetailOption.reportName);
        // 先获取字段设置
        this.userDetailOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.userDetailOption.reportName, this.userDetailOption.tableFields);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivilegesSummary(eurekaActiveUserDetailParams).then(data => {
            this.userDetailOption.noData = data.iTotalRecords === 0;
            this.userDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.userDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.userDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.userDetailOption.tableOptions.rows = makeEurekaActiveUserTableRows(data.aaData);
        }).catch(() => {
            this.userDetailOption.noData = true;
            this.userDetailOption.tableOptions.rows = [];
        }).finally(() => {
            this.userDetailOption.loading = false;
        });
    }
    getCompanyDataAnalysisEurekaUsageDownload(params) {
        let eurekaActiveUserDetailParams = _.cloneDeep(params);
        eurekaActiveUserDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.userDetailOption.reportName);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUsageDownload(eurekaActiveUserDetailParams, 'eureka-usage');
    }
    initData(params) {
        Promise.all([
            // this.getNoveltyCheckData(params),
            // this.getSearchData(params),
            this.getNewUserPermissionData(params),
            this.getNewUserPermissionDetailsData(params),
            this.getLoginEurekaPvUvData(params),
            this.getRdPvUvData(params),
            this.getIpPvUvData(params),
            this.getMaterialsPvUvData(params)
        ]);
    }
};
CompanyEurekaDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyDataAnalysisService)),
    __param(1, inject(Symbols.CompanyDataAnalysisApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyEurekaDataAnalysisService);
export { CompanyEurekaDataAnalysisService };
